module.exports = __webpack_public_path__ + "static/media/polygon.7d24513a.svg";